<template>
	<BModal id="booking-update-frequency-modal"
		centered
		title="Update Your Booking Frequency"
		size="md">
		<template v-if="booking">
			<BForm>
				<BFormGroup v-if="booking.service === 'Regular'"
					:state="getValidationState('frequency')"
					class="mb-0 my-2">
					<div
						class="d-flex flex-1 btn-group-toggle btn-group bv-no-focus-ring"
						role="radiogroup"
						aria-label="Booking frequency">
						<label
							class="flex-1 btn btn-white mb-0 rounded-left-05"
							:class="{ active: frequency === 'Weekly' }"
							for="booking-frequency-weekly">
							<input
								id="booking-frequency-weekly"
								v-model="frequency"
								type="radio"
								name="booking-frequency"
								value="Weekly"
								autocomplete="off">
							Weekly
						</label>
						<label
							class="flex-1 btn btn-white mb-0 rounded-right-05"
							:class="{ active: frequency === 'Fortnightly' }"
							for="booking-frequency-fortnightly">
							<input
								id="booking-frequency-fortnightly"
								v-model="frequency"
								type="radio"
								name="booking-frequency"
								value="Fortnightly"
								autocomplete="off">
							Fortnightly
						</label>
					</div>
					<BFormInvalidFeedback :state="getValidationState('frequency')">
						{{ getValidationErrors('frequency') }}
					</BFormInvalidFeedback>
				</BFormGroup>
			</BForm>
		</template>
		<template #footer>
			<div class="d-flex justify-content-end gap-sm">
				<BButton variant="light" @click="$bvModal.hide('booking-update-frequency-modal')">
					Close
				</BButton>
				<BButton variant="primary" :disabled="submitting"
					@click="handleSubmit">
					<BSpinner v-if="submitting" small
						class="mr-2"></BSpinner>
					Update Frequency
				</BButton>
			</div>
		</template>
	</BModal>
</template>

<script>
	import { useValidation } from '@js/composables/useValidation.js';

	export default {
		props: {
			booking: {
				type: Object,
				required: true,
			}
		},
		emits: ['booking-updated'],
		setup() {
			return {
				...useValidation(),
			};
		},
		data() {
			return {
				frequency: this.booking.frequency,
				submitting: false,
			}
		},
		watch: {
			'booking.frequency': {
				immediate: true,
				handler(frequency) {
					this.frequency = frequency;
				},
			},
		},
		methods: {
			async handleSubmit() {
				this.submitting = true;

				if (this.frequency === this.booking.frequency) {
					this.$bvToast.toast('No changes made', {
						title: 'No changes',
						variant: 'info',
						solid: true,
					})
					this.$bvModal.hide('booking-update-frequency-modal')
					this.submitting = false;
					return;
				}

				await this.$axios.post(`/api/client/bookings/${this.booking.unique_id}/update-frequency`, {
					frequency: this.frequency
				}).then(() => {
					this.$bvToast.toast('Booking frequency updated', {
						title: 'Success',
						variant: 'success',
						solid: true,
					})
					this.$emit('booking-updated')
					this.$bvModal.hide('booking-update-frequency-modal')
					this.clearErrors();
				}).catch(error => {
					this.handleError(error);
				})

				this.submitting = false;
			}
		}
	}
</script>
